module.exports = __webpack_public_path__ + "img/telkie.8766663e.png";